import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Taats from "../../doors/taats";
import Paneel from "../../doors/paneel";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface SingleTaatsSinglePanelProps extends ConfigurationProps {}
const SingleTaatsSinglePanel: React.FC<SingleTaatsSinglePanelProps> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: SingleTaatsSinglePanelProps) => {
  const position0 = new Vector3(-0.448, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([position0, position1]));
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale} scale-y={0.996}>
      <Taats
        materials={materials}
        position={positions[0]}
        rotation={rotation}
        index={0}
        frameSettings={doorSettings?.main?.frameSettings}
      />
      <Paneel
        materials={materials}
        position={positions[1]}
        index={1}
        frameSettings={doorSettings?.secondary?.frameSettings}
      />
    </group>
  );
};

export default SingleTaatsSinglePanel;
